import { Component, DoCheck, Input } from '@angular/core';
import { DropdownQuestionV3 } from '../../../classes/question-dropdown';
import { QuestionBaseV3ComponentDirective } from '../question-base.component';

@Component({
  selector: 'bepatient-input-dropdown-v3',
  templateUrl: './input-dropdown.component.html',
  styleUrls: ['./input-dropdown.component.scss'],
  standalone: false
})
export class InputDropdownComponentV3
  extends QuestionBaseV3ComponentDirective
  implements DoCheck
{
  @Input() question: DropdownQuestionV3;
  @Input() color: string;
  dirty: boolean;

  customPopoverOptions: any = {
    cssClass: 'bepatient_dynamic_form_multiSelect_popover',
    mode: 'md'
  };

  get value() {
    return this.formGroup.get(this.question.key).value;
  }

  onBlur(): void {
    this.formGroup.get(this.question.key).markAsDirty();
    this.dirty = this.formGroup.get(this.question.key).dirty;
  }

  onSelect(): void {
    this.dirty = this.formGroup.get(this.question.key).dirty;
  }

  ngDoCheck(): void {
    this.dirty = this.formGroup.get(this.question.key).dirty;
  }
}
